import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';
import { flatMap, map } from 'rxjs/operators';

@Injectable()
export class InstallationYesNoPluginService extends InspectionPluginService {
  private statusKeys = [
    { value: 1, label: 'plugins.installationyesno.yes' },
    { value: 2, label: 'plugins.installationyesno.no' },
    { value: 3, label: 'plugins.installationyesno.na' }
  ];

  private statuses = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null, inspectionFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  public updateYesNo(inspectionId: string, pointId: string, pluginId: string, questions: any[]): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, questions).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  public getStatuses() {
    return this.statuses;
  }

  private applyTranslations() {
    this.statuses = [];
    this.copyTranslationValues(this.statusKeys, this.statuses, this.language);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, questions: any[]): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, questions, 'Questions').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
